<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M9.61.46,25.14,16,9.61,31.52a1.64,1.64,0,0,1-.52.35,1.5,1.5,0,0,1-.62.13,1.67,1.67,0,0,1-.62-.12A1.63,1.63,0,0,1,7,31a1.67,1.67,0,0,1-.12-.62A1.59,1.59,0,0,1,7,29.77a1.73,1.73,0,0,1,.36-.52L20.6,16,7.34,2.73A1.56,1.56,0,0,1,6.88,1.6,1.61,1.61,0,0,1,7.35.47a1.61,1.61,0,0,1,2.26,0Z"
    />
</svg>